import React from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import { useState, useEffect } from "react";
import { UserManager, User, WebStorageStateStore } from "oidc-client";
import axios from "axios";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
function JLRSSOResponse() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");

  useEffect(() => {
    if (code && code != "") {
      GetUserLoggedInJLRSSO(code);
    } else {
      window.location = "/ssologin" as any;
    }
  }, [code]);

  function GetUserLoggedInJLRSSO(code: any) {
    let object = {} as any;
    object.tkn = code;
    axios
      .post(
        AppContext.AppAuthBaseURL + "api/SiteUser/GetUserLoggedInJLRSSO",
        object,
        { withCredentials: true }
      )
      .then((response) => {
        console.log(response);
        if (response.data.Status === 1) {
          var l_response = response.data;
          window.location = AppContext.LinkMBT as any;
        } else {
          window.location = "/login" as any;
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  return (
    <div className="page--contents">
      <div>
        <LoadingAnimation />
      </div>
    </div>
  );
}

export default JLRSSOResponse;
